<div *ngIf="imageVisible" style="border: 1px dotted #ddd;border-radius: 0px;padding: 15px 10px;" fxLayout="row"
  fxLayoutAlign="space-between center" fxLayoutGap="10px">
  <div fxLayout="column">
    <span>Figure</span>
      <calsoft-common-images [src]="serverPath+value"
      [height]="'50px'" 
      [width]="'auto'"
      [alt]="">
      </calsoft-common-images>
  </div>
  <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
    <button [attr.guide]="'whatsapp-images-btn-1' + '__' + sanitizedUrl" (click)="downloadImage1(serverPath+value)"
    color="warn" mat-icon-button type="button"
    class="center-button btn-video btn-iframe">
    <mat-icon>download</mat-icon>
  </button>
  </div>

  <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
    <button [attr.guide]="'whatsapp-images-btn-2' + '__' + sanitizedUrl" (click)="logo()" mat-raised-button>
        <mat-icon>cloud_upload</mat-icon>
        <span>Upload</span>
    </button>

    <button [attr.guide]="'whatsapp-images-btn-3' + '__' + sanitizedUrl" *ngIf="value!=''" (click)="deleteImage()" mat-raised-button>delete</button>
  </div>
</div>

<div *ngIf="!imageVisible&&!imageDelete" style="border: 1px dotted #ddd;border-radius: 0px;padding: 15px 10px;" fxLayout="row"
  fxLayoutAlign="space-between center" fxLayoutGap="10px">
  <calsoft-common-file-upload (fileUploadResult)=getResult($event) [type]="'whatsapp'">
  </calsoft-common-file-upload>
  <button [attr.guide]="'whatsapp-images-btn-4' + '__' + sanitizedUrl" (click)="cancelUpload()" mat-raised-button>Cancel</button>
</div>